import { MultipleChoice } from '@unmind/design-system';
import { rem } from 'polished';
import styled from 'styled-components';

export const P = styled.p`
  margin: 0;
  font-size: ${rem(14)};
  color: ${({ theme }) => theme.colors.book.eapService.dateAndTime};
  line-height: 140%;
`;

export const TimeSelection = styled(MultipleChoice)`
  .timeselection {
    margin-top: ${rem(8)};
  }

  && legend {
    color: ${({ theme }) => theme.colors.text.secondary};
    font-size: ${rem(14)};
    font-weight: ${({ theme }) => theme.typography.fontWeights.regular};
    line-height: ${rem(16)};
  }

  ul {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: ${rem(16)};
  }

  li.multiple-choice-option-wrapper {
    margin-bottom: 0;
    font-size: ${rem(16)};
  }

  label {
    padding: ${rem(12)} ${rem(16)};
    justify-content: center;
  }
`;
